export type CatalogSort = 'newest' | 'oldest';

export const CATALOG_SORTS: { id: CatalogSort; title: string }[] = [
  { id: 'newest', title: 'Newest First' },
  { id: 'oldest', title: 'Oldest First' },
];
